


<template>
  <w-app>
    <!-- <ul>
                    <li v-for="user in Users" :key="user.id">{{ user }}</li>
                  </ul> -->
    <TitleBarView></TitleBarView>

    <router-view v-slot="{ Component }">
      <keep-alive :exclude="Cart.name">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </w-app>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #103861;

}

/* @media (prefers-dark-interface) {
  #app {
    color: white;
    background: black
  }
} */

@media (prefers-color-scheme: dark) {
  #app {
    /* background-color: rgb(41, 40, 40);
    color: white; */


  }

}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #103861;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.dark {
  background: #16171d;
  color: #fff;
}
</style>
<script setup>
import TitleBarView from "./views/TitleBarView.vue"
import Cart from "./views/ShoppingBasketView.vue"

import { ref, onMounted } from 'vue'
import useSupabase from './lib/supabaseClient'
const { supabase } = useSupabase();
const Users = ref({ name: "test" })
async function getUsers() {
  supabase.channel('table-db-changes')
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'profiles',
      },
      (payload) => { Users.value.push(payload.new) }

    )
    .subscribe()
  const { data } = await supabase.from('profiles').select('*')
  console.log("getUsers", data);
  Users.value = data
}

onMounted(() => {

  getUsers()
})




</script>
